// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import CheckoutFailTemplate from 'components/checkout/CheckoutFailTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

type Props = {
  subject: any,
  loading: any,
};

class CheckoutFailTemplateContainer extends Component<Props> {
  render() {
    const { history, order, loading } = this.props;
    if (!order.id) {
      history.replace('/cart');
      return false;
    }
    if (loading === undefined || loading)
      return <Circles color="blue" size="medium" text="Loading..." />;
    return <CheckoutFailTemplate order={order} />;
  }
}

export default connect(
  ({ orders, pender }: State) => ({
    order: orders.order,
    loading: pender.pending['orders/GET_ORDER'],
  }),
  () => ({}),
)(withRouter(CheckoutFailTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/checkout/CheckoutFailTemplateContainer.js